export interface GetDealCalculatorModel {
  dealId: string | undefined;
  contactId: string | undefined;
  isDealEdit: boolean | undefined;
  isEstimatedScore: boolean | undefined;
  estimatedScore: number | null | undefined;
}

export interface IInputs {
  cashOut: number;
  downPayment: number;
  term: number;
  rateMarkup: number;
  approvedRate: number;
  comRetail?: number;
  contractDate?: string;
  firstPaymentDays?: number;
  gapRetail?: number;
  isAch?: boolean;
  lenderCode?: string;
  pafRetail?: number;
  rateAdjustment?: number;
  totalDebt?: number;
  totalUnsecuredDebt?: number;
  vrpRetail?: number;
  vscRetail?: number;
  mbiRetail?: number;
  isDeclined?: boolean;
}

export class InputsModel implements Partial<IInputs> {
  cashOut?: number;
  downPayment?: number;
  term?: number;
  rateMarkup?: number;
  approvedRate?: number;
  comRetail?: number;
  contractDate?: string;
  firstPaymentDays?: number;
  gapRetail?: number;
  isAch?: boolean;
  lenderCode?: string;
  pafRetail?: number;
  rateAdjustment?: number;
  totalDebt?: number;
  totalUnsecuredDebt?: number;
  vrpRetail?: number;
  vscRetail?: number;
  mbiRetail?: number;
  isDeclined?: boolean;

  constructor(data?: Partial<IInputs>) {
    if (data) {
      this.cashOut = data.cashOut;
      this.downPayment = data.downPayment;
      this.term = data.term;
      this.rateMarkup = data.rateMarkup;
      this.approvedRate = data.approvedRate;
      this.comRetail = data.comRetail;
      this.contractDate = data.contractDate;
      this.firstPaymentDays = data.firstPaymentDays;
      this.gapRetail = data.gapRetail;
      this.isAch = data.isAch;
      this.lenderCode = data.lenderCode;
      this.pafRetail = data.pafRetail;
      this.rateAdjustment = data.rateAdjustment;
      this.totalDebt = data.totalDebt;
      this.totalUnsecuredDebt = data.totalUnsecuredDebt;
      this.vrpRetail = data.vrpRetail;
      this.vscRetail = data.vscRetail;
      this.mbiRetail = data.mbiRetail;
      this.isDeclined = data.isDeclined;
    }
  }
}
